import React, { useEffect, useMemo, useState } from "react";
import "./Host.css";
import DefaultHostImage from "../../assets/images/profile_image.png";
import Button from "../../components/Button/Button3";

const Host = ({ host }) => {
  const hostName = host?.first_name || "Host";
  // const hostName = `${host?.first_name || ""} ${host?.last_name || ""}`.trim() || "Host";

  const [showContactCard, setShowContactCard] = useState(false);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  const backendUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
  const hostPicture = host?.hostPicture || host?.profilePictureUrl || "";

  const resolvedHostImgSrc = useMemo(() => {
    if (!hostPicture) return DefaultHostImage;
    if (hostPicture.startsWith("http")) return hostPicture;
    return `${backendUrl}${hostPicture}`;
  }, [backendUrl, hostPicture]);

  useEffect(() => {
    setImageLoadFailed(false);
  }, [hostPicture]);

  const hostImgSrc = imageLoadFailed ? DefaultHostImage : resolvedHostImgSrc;

  const normalizedDescription =
    typeof host?.description === "string" ? host.description.trim() : "";
  const hostDescription =
    normalizedDescription ||
    `I am excited to host this friendly match today and look forward to
     seeing some excellent football. Let's remember to play with respect and
     sportsmanship, and most importantly, have fun out there!`;

  const handleContactClick = () => setShowContactCard(true);
  const handleCloseCard = () => setShowContactCard(false);

  return (
    <div className="host-container">
      <div className="host-info">
        <h1>{hostName}</h1>
        <p>{hostDescription}</p>
        <Button
          variant="small"
          primaryText="CONTACT"
          styleType="default"
          onClick={handleContactClick}
        />
      </div>

      <div className="host-image">
        <img
          src={hostImgSrc}
          alt={`Host ${hostName}`}
          onError={() => setImageLoadFailed(true)}
        />
      </div>

      {showContactCard && (
        <div className="contact-card-overlay" onClick={handleCloseCard}>
          <div className="contact-card" onClick={(e) => e.stopPropagation()}>
            <h3>Contact {hostName}</h3>
            <p>
              <strong>Email:</strong> {host.email}
            </p>
            <p>
              <strong>Phone:</strong> {host?.phone_number}
            </p>
            <Button
              variant="small"
              primaryText="CLOSE"
              styleType="default"
              onClick={handleCloseCard}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Host;
